<template>
  <div class="offer">
    <div class="offer_header">
      <div>
        <div>
          <img class="offer_user_image" v-lazy-load :data-src="getUser(offer.userId).image">
          {{ getUser(offer.userId).name }}
        </div>
      </div>
      <div class="offer_title">
        You got credit
      </div>
      <div>
        Expiration
        <div>
          {{ getFormattedDate(offer.validThru) }}
        </div>
      </div>
    </div>
    <div class="details">
      <div class="status">
        <div>Credit value: {{ offer.offerCurrencyType + offer.offerSum }}</div>
        <div v-if="expirationDays >= 0">
          Your credit will expire in {{ creditExpireIn }}
        </div>
        <div v-else class="credit_expired">
          Credit expired
        </div>
      </div>
      <div class="order_details">
        <!--        <img class="item_image pointer" v-lazy-load :data-src="getItem(order.itemId).image" @click="showItem(order.itemId)">-->
        <div class="offer_details">
          <div>{{ offer.offerComment }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'OfferComponent',
  props: {
    offer: Object
  },
  data () {
    return {
      monthNames: [
        'January', 'February', 'March', 'April',
        'May', 'June', 'July', 'August', 'September',
        'October', 'November', 'December']
    }
  },
  computed: {
    expirationDays () {
      return parseInt(((this.offer.validThru - new Date().getTime()) / (1000 * 60 * 60 * 24)))
    },
    creditExpireIn () {
      const expirationDays = parseInt(((this.offer.validThru - new Date().getTime()) / (1000 * 60 * 60 * 24)))
      return expirationDays === 0
        ? 'less than one day'
        : ('' + (this.expirationDays + expirationDays === 1
            ? ' day'
            : (expirationDays) + ' days'))
    }
  },
  methods: {
    getFormattedDate (date) {
      date = new Date(date)
      const day = date.getDate()
      const monthIndex = date.getMonth()
      const year = date.getFullYear()
      return this.monthNames[monthIndex] + ' ' + day + ', ' + year
    },
    getItem (itemId) {
      return this.$store.state.api.buckets.items[itemId]
    },
    getDraftOrder (draftOrderId) {
      return this.$store.state.api.buckets.draftOrders[draftOrderId]
    },
    getShippingType (shippingTypeId) {
      return this.$store.state.api.buckets.shippingTypes[shippingTypeId]
    },
    getUser (userId) {
      return this.$store.state.api.buckets.users[userId]
    }
  }
}
</script>

<style scoped>
.offer {
  width: 920px;
  border-radius: 4px;
  border: 1px #ddd solid;
  margin: auto auto 1em;
}

.mobile_design .offer {
  width: calc(100% - 1em);
  margin-left: 0.5em;
  margin-right: 0.5em;
}

.offer_header {
  display: flex;
  padding: 1em;
  background-color: #f6f6f6;
  border-bottom: 1px #ddd solid;
}

.offer_title {
  flex-grow: 1;
  text-align: center;
}

a {
  color: #0066c0;
  cursor: pointer;
}

.ship_to {
  margin-left: 5em;
}

.status {
  font-weight: 700;
  font-size: 17px;
}

.details {
  padding: 1em;
}

.item_image {
  width: 90px !important;
  height: 90px !important;
  margin-right: 1em;
}

.order_details {
  display: flex;
  margin-top: 1em;
}

.item_price {
  color: #B12704;
}

.offer_user_image {
  width: 70px !important;
  height: 70px !important;
  border-radius: 50%;
}

.credit_expired {
  color: red;
  font-weight: bold;
}

.offer_details {
  flex-grow: 1;
}
</style>
